Vue.component("linechart", {
  props: {
    featured: {
      type: Array
    },
    data: { default: false },
    forecast: { default: false },
    isloaded: { default: false }
  },
  data() {
    return {
      chartid: "chart_" + this.makeid(),
      svg: false,
      width: 500,
      height: 200,
      margin: { top: 30, right: 10, bottom: 10, left: 10 }
    };
  },
  watch: {
    isloaded(val) {
      if (val) {
        this.drawChart();
      }
    }
  },
  mounted() {
    if (this.isloaded) {
      this.drawChart();
    }
  },
  methods: {
    drawChart() {
      let $this = this;
      let translateleft = $this.margin.left + 20;
      $this.svg = d3.select("#" + $this.chartid + " svg");
      $this.svg.attr("viewBox", [
        0,
        0,
        this.width + $this.margin.right + $this.margin.left + 30,
        this.height + this.margin.top + this.margin.bottom + 20
      ]);
      let innerChart = $this.svg
        .append("g")
        .attr("transform", `translate(${translateleft} ${$this.margin.top})`);

      const x = d3.scaleTime().rangeRound([0, $this.width]);
      const y = d3.scaleLinear().rangeRound([$this.height, 0]);

      const line = d3
        .line()
        .x((d) => x(d.date))
        .y((d) => y(d.value));

      if (this.forecast) {
        x.domain([d3.min($this.data, (d) => d.date), d3.max($this.forecast, (d) => d.date)]);
      } else {
        x.domain([d3.min($this.data, (d) => d.date), d3.max($this.data, (d) => d.date)]);
      }
      y.domain([0, d3.max($this.data, (d) => d.value)]);

      innerChart
        .append("g")
        .attr("transform", `translate(0 ${$this.height})`)
        .call(d3.axisBottom(x));

      innerChart
        .append("g")
        .call(d3.axisLeft(y))
        .append("text")
        .attr("fill", "#000")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", "0.71em");

      innerChart
        .append("path")
        .datum($this.data)
        .attr("fill", "none")
        .attr("stroke", "#0055A2")
        .attr("stroke-width", 1.5)
        .attr("d", line);

      if ($this.forecast && $this.forecast.length > 0) {
        innerChart
          .append("path")
          .datum($this.forecast)
          .attr("fill", "none")
          .attr("stroke", "tomato")
          .attr("stroke-dasharray", "10,7")
          .attr("stroke-width", 1.5)
          .attr("d", line);
      }
    },
    makeid() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 10; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    }
  }
});
